import React from 'react'
import ChristmasCelebration23_24 from'../Assets/Images/ChristmasCelebration23_24.jpg'
import DiwaliCelebration2023 from'../Assets/Images/DiwaliCelebration2023.jpg'
import NurseryInteraction23_24 from'../Assets/Images/NurseryInteraction23_24.jpg'
import SchoolTrip2023 from'../Assets/Images/SchoolTrip2023.jpg'
import VeerBalDiwas from'../Assets/Images/VeerBalDiwas.jpg'
import { Link } from 'react-router-dom'
const PhotoGallery = () => {
  return (
    <>
    <div className="innerslide">
    <ul className="breadcrumb">
    <li><Link to="/"> Home</Link> </li>
        <li>  Gallery</li>
        <li>  Photo Gallery </li>
    </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
       <div className="col-lg-12">
             <h1>  Photo Gallery </h1>
        </div>
     </div>
     <div className="row tabs-dynamic">
            <div className="col-md-3">
                <div className="count-val">
                    <p>Total Count:</p>
                </div>
            </div>
             <div className="col-md-3">
                <div className="month-selection">
                   <select className="yearSelection">
                        <option className="2024" selected>2024</option>
                        <option className="2023">2023</option>
                    </select>
                </div>
            </div>
            <div className="col-md-3">
                <div className="month-selection">
                    <select className="monthSelect">
                        <option value="0">All Month</option>
                        <option value="1">Jan</option>
                        <option value="2">Feb</option>
                        <option value="3">Mar</option>
                        <option value="4">Apr</option>
                        <option value="5">May</option>
                        <option value="6">Jun</option>
                        <option value="7">Jul</option>
                        <option value="8">Aug</option>
                        <option value="9">Sep</option>
                        <option value="10">Oct</option>
                        <option value="11">Nov</option>
                        <option value="12">Dec</option>
                    </select>
                </div>
            </div>
            <div className="col-md-3">
                <div className="searchBox">
                    <input type="text" id="myInput" name="name" autocomplete="off" placeholder="Search Here.." />
                </div>
            </div>
        </div>     
        <div className="row years year2024 showYear">

           
        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount " data-month="1">
                <div className="gallery-inner">
                <div className="gallery-blks">
                    <div className="backDiv"></div>
                    <img src={ChristmasCelebration23_24} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
                </div>
                <div className="gallery-content">
                <div className="gallery-date">
                        <h6>30<span>  Jan </span> </h6>
                         <div className="gall-num">
                        <h5><span>Number Of Photos :</span>05</h5>
                    </div>
                    </div>
                    <div className="gallery-title">
                        <h3>Christmas Celebration </h3>
                    </div>
                   
                    
                    <Link to="SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
                </div>
            </div>
            </div>
             <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount " data-month="1">
                <div className="gallery-inner">
                <div className="gallery-blks">
                    <div className="backDiv"></div>
                    <img src={DiwaliCelebration2023} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
                </div>
                <div className="gallery-content">
                <div className="gallery-date">
                        <h6>30<span>  Jan </span> </h6>
                         <div className="gall-num">
                        <h5><span>Number Of Photos :</span>05</h5>
                    </div>
                    </div>
                    <div className="gallery-title">
                        <h3>Diwali Celebration </h3>
                    </div>
                   
                    
                    <Link to="SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
                </div>
            </div>
            </div>
             <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount " data-month="2">
                <div className="gallery-inner">
                <div className="gallery-blks">
                    <div className="backDiv"></div>
                    <img src={NurseryInteraction23_24} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
                </div>
                <div className="gallery-content">
                <div className="gallery-date">
                        <h6>30<span>  Jan </span> </h6>
                         <div className="gall-num">
                        <h5><span>Number Of Photos :</span>05</h5>
                    </div>
                    </div>
                    <div className="gallery-title">
                        <h3>Nursery Interaction </h3>
                    </div>
                   
                    
                    <Link to="SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
                </div>
            </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount " data-month="2">
                <div className="gallery-inner">
                <div className="gallery-blks">
                    <div className="backDiv"></div>
                    <img src={SchoolTrip2023} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
                </div>
                <div className="gallery-content">
                <div className="gallery-date">
                        <h6>30<span>  Jan </span> </h6>
                         <div className="gall-num">
                        <h5><span>Number Of Photos :</span>05</h5>
                    </div>
                    </div>
                    <div className="gallery-title">
                        <h3>School Trip </h3>
                    </div>
                   
                    
                    <Link to="SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
                </div>
            </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount " data-month="2">
                <div className="gallery-inner">
                <div className="gallery-blks">
                    <div className="backDiv"></div>
                    <img src={VeerBalDiwas} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
                </div>
                <div className="gallery-content">
                <div className="gallery-date">
                        <h6>30<span>  Jan </span> </h6>
                         <div className="gall-num">
                        <h5><span>Number Of Photos :</span>05</h5>
                    </div>
                    </div>
                    <div className="gallery-title">
                        <h3>Veer Bal Diwas</h3>
                    </div>
                   
                    
                    <Link to="SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
                </div>
            </div>
            </div>
           <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount " data-month="2">
                <div className="gallery-inner">
                <div className="gallery-blks">
                    <div className="backDiv"></div>
                    <img src={ChristmasCelebration23_24} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
                </div>
                <div className="gallery-content">
                <div className="gallery-date">
                        <h6>30<span>  Jan </span> </h6>
                         <div className="gall-num">
                        <h5><span>Number Of Photos :</span>05</h5>
                    </div>
                    </div>
                    <div className="gallery-title">
                        <h3>Christmas Celebration </h3>
                    </div>
                   
                    
                    <Link to="SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
                </div>
            </div>
            </div>
            <div className="load-more">
                <div className="next">Show More</div>
            </div>
        </div>
        <div className="row years year2023">
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount " data-month="1">
                <div className="gallery-inner">
                <div className="gallery-blks">
                    <div className="backDiv"></div>
                    <img src={ChristmasCelebration23_24} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
                </div>
                <div className="gallery-content">
                <div className="gallery-date">
                        <h6>30<span>  Jan </span> </h6>
                         <div className="gall-num">
                        <h5><span>Number Of Photos :</span>05</h5>
                    </div>
                    </div>
                    <div className="gallery-title">
                        <h3>Christmas Celebration </h3>
                    </div>
                   
                    
                    <Link to="SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
                </div>
            </div>
            </div>
             <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount " data-month="1">
                <div className="gallery-inner">
                <div className="gallery-blks">
                    <div className="backDiv"></div>
                    <img src={DiwaliCelebration2023} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
                </div>
                <div className="gallery-content">
                <div className="gallery-date">
                        <h6>30<span>  Jan </span> </h6>
                         <div className="gall-num">
                        <h5><span>Number Of Photos :</span>05</h5>
                    </div>
                    </div>
                    <div className="gallery-title">
                        <h3>Diwali Celebration</h3>
                    </div>
                   
                    
                    <Link to="SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
                </div>
            </div>
            </div>
             <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount " data-month="2">
                <div className="gallery-inner">
                <div className="gallery-blks">
                    <div className="backDiv"></div>
                    <img src={NurseryInteraction23_24} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
                </div>
                <div className="gallery-content">
                <div className="gallery-date">
                        <h6>30<span>  Jan </span> </h6>
                         <div className="gall-num">
                        <h5><span>Number Of Photos :</span>05</h5>
                    </div>
                    </div>
                    <div className="gallery-title">
                        <h3>Nursery Interaction</h3>
                    </div>
                   
                    
                    <Link to="SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
                </div>
            </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount " data-month="2">
                <div className="gallery-inner">
                <div className="gallery-blks">
                    <div className="backDiv"></div>
                    <img src={SchoolTrip2023} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
                </div>
                <div className="gallery-content">
                <div className="gallery-date">
                        <h6>30<span>  Jan </span> </h6>
                         <div className="gall-num">
                        <h5><span>Number Of Photos :</span>05</h5>
                    </div>
                    </div>
                    <div className="gallery-title">
                        <h3>School Trip</h3>
                    </div>
                   
                    
                    <Link to="SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
                </div>
            </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount " data-month="2">
                <div className="gallery-inner">
                <div className="gallery-blks">
                    <div className="backDiv"></div>
                    <img src={VeerBalDiwas} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
                </div>
                <div className="gallery-content">
                <div className="gallery-date">
                        <h6>30<span>  Jan </span> </h6>
                         <div className="gall-num">
                        <h5><span>Number Of Photos :</span>05</h5>
                    </div>
                    </div>
                    <div className="gallery-title">
                        <h3>Veer Bal Diwas</h3>
                    </div>
                   
                    
                    <Link to="SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
                </div>
            </div>
            </div>
           <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount " data-month="2">
                <div className="gallery-inner">
                <div className="gallery-blks">
                    <div className="backDiv"></div>
                    <img src={ChristmasCelebration23_24} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
                </div>
                <div className="gallery-content">
                <div className="gallery-date">
                        <h6>30<span>  Jan </span> </h6>
                         <div className="gall-num">
                        <h5><span>Number Of Photos :</span>05</h5>
                    </div>
                    </div>
                    <div className="gallery-title">
                        <h3>Christmas Celebration </h3>
                    </div>
                   
                    
                    <Link to="SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
                </div>
            </div>
            </div>
             <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 galleryCount " data-month="2">
                <div className="gallery-inner">
                <div className="gallery-blks">
                    <div className="backDiv"></div>
                    <img src={ChristmasCelebration23_24} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
                </div>
                <div className="gallery-content">
                <div className="gallery-date">
                        <h6>30<span>  Jan </span> </h6>
                         <div className="gall-num">
                        <h5><span>Number Of Photos :</span>05</h5>
                    </div>
                    </div>
                    <div className="gallery-title">
                        <h3>Christmas Celebration </h3>
                    </div>
                   
                    
                    <Link to="SubGallery" className="view-more">View More <i className="bi bi-arrow-right"></i></Link>
                </div>
            </div>
            </div>

            <div className="load-more">
                <div className="next">Show More</div>
            </div>
        </div>

</div>
</div>
    </>
  )
}

export default PhotoGallery
